import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useApiRequest from "../../../hook/useApiRequest";
import Joi from "joi";
import { API_ENDPOINTS } from "../../../constants/endPoints";

const orderchatadminViewUtils = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loading, fetchData } = useApiRequest();

  const [formData, setFormData] = useState([]);
  const [location, setLocation] = useState([]);

  const fetchOrderData = async () => {
    const response = await fetchData(
      `${API_ENDPOINTS?.get_orders_chat}/${id}`,
      navigate
    );

    console.log("response",response)

    if (response) {
      setFormData(response?.messages);
      setLocation(response?.orderLocation);
    }
  };

  useEffect(() => {
    fetchOrderData();
  }, [id]);

 

  return {
    formData,
    loading,
    fetchData,
    location,
    id
    
 
  };
};

export default orderchatadminViewUtils;
